import { render, staticRenderFns } from "./DmForm.vue?vue&type=template&id=6278413a"
import script from "./DmForm.vue?vue&type=script&lang=js"
export * from "./DmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports